import React from 'react';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { TurnButton } from '../../../../../../../BaseComponents';
import { CdnIcon, SafeHtml } from '@shared/ui';
import { useFareOverrides } from '../../../../model/useFareOverrides';
const Upgrade = ({ className, variant = 'upgrade', upgradeOption, onUpgrade }) => {
    var _a, _b;
    const { Upgrade: css } = useTheme('Entities').FareGroupV2;
    const { t } = useTranslation('FareGroup');
    const { renderFareOptionsTypeIcon } = useFareOverrides();
    const isUpgrade = variant === 'upgrade';
    const isSubscribe = variant === 'subscribe';
    const nextFareTitle = (_b = (_a = upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.canUpgradeTo) === null || _a === void 0 ? void 0 : _a.fareFamily) === null || _b === void 0 ? void 0 : _b.title;
    const showUpgradeOffer = !!(upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeOffer);
    const showNextFareTitle = isUpgrade && !!nextFareTitle;
    return (React.createElement("div", { className: cn(css.root, className, css[variant]), onClick: onUpgrade },
        React.createElement("div", { className: css.header },
            showUpgradeOffer && React.createElement(SafeHtml, { tag: "span", className: css.text, html: upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeOffer }),
            showNextFareTitle && (React.createElement("span", { className: css.text },
                t('Choose'),
                " ",
                nextFareTitle))),
        React.createElement("div", { className: css.footer },
            React.createElement("div", { className: css.icons },
                isUpgrade && (React.createElement("div", { key: 'Action/Add', className: css.icon },
                    React.createElement(CdnIcon, { icon: "Action/Add" }))),
                (upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.optionsAvailableOnNextFare.length) > 0 &&
                    (upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.optionsAvailableOnNextFare.map((type, index) => (React.createElement("div", { key: index, className: css.icon }, renderFareOptionsTypeIcon(type)))))),
            React.createElement("div", { className: css.buttonWrapper },
                isSubscribe && React.createElement("span", { className: css.text }, t('View options')),
                React.createElement(TurnButton, { className: css.button })))));
};
export default Upgrade;
